import { authHeader } from '../_helpers';
import "isomorphic-fetch";
import { history } from '../_helpers';
import { handleResponse } from './responseHandler';
import { userConstants } from '../_constants';

export const userService = {
    login,
    logout,
    getById,
    useRefreshToken,
    deactivateUser,
    activateUser,
    register,
    activateAccount,
    updateUser,
    setUpResetPassword,
    resetPassword,
    toggleRetirement
};

function login(email, password) {

    var details = {
        'username': email,
        'password': password,
        'grant_type': 'password'
    };

    var formBody = [];
    for (var property in details) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");

    return window.fetch(process.env.REACT_APP_API_BASE_URL+'/oauth/token', {
        method: 'POST',
        headers: {
            'Authorization': 'Basic ' + btoa("pathwaysolutions"+':'+"e4a33bd84987c896955bd09afbc2918c2b3610472703b0288993a96a12c9f3fe"),
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: formBody
        })
        .then(response => {
            if (!response.ok) {
                if (response.status === 400) {
                    return Promise.reject("Sie konnten nicht angemeldet werden. Falls Sie ihre Zugangsdaten vergessen haben klicken Sie bitte auf den Link unten um ihr Passwort zurückzusetzen.");
                }
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user && user.access_token) {
                localStorage.setItem('hmtguser', JSON.stringify(user));
            }

            return user;
        })
        .then(initialUserData => {

            // retrieve additional user details
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };

            return window.fetch(process.env.REACT_APP_API_BASE_URL+'/user', requestOptions).then(additionalUserData => {

                if (!additionalUserData.ok) {
                    return Promise.reject(additionalUserData.statusText);
                }

                return additionalUserData.json().then((jsonData) =>{
                    let user = JSON.parse(localStorage.getItem('hmtguser'));

                    for(var key in jsonData) {user[key] = jsonData[key];}
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('hmtguser', JSON.stringify(user));
                    return user;
                });
            });
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('hmtguser');
}

function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return window.fetch('/users/' + id, requestOptions).then(handleResponse);
}

function useRefreshToken() {

    let user = JSON.parse(localStorage.getItem('hmtguser'));

    var details = {
        'refresh_token': user.refresh_token,
        'grant_type': 'refresh_token'
        };

    var formBody = [];
    for (var property in details) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");

    return window.fetch(process.env.REACT_APP_API_BASE_URL+'/oauth/token', {
        method: 'POST',
        headers: {
            'Authorization': 'Basic ' + btoa("pathwaysolutions"+':'+"secretforbasicauth"),
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: formBody
        })
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user && user.access_token) {
                localStorage.setItem('hmtguser', JSON.stringify(user));
            }
            return user;
        })
        .then(initialUserData => {

            // retrieve additional user details
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };

            return window.fetch(process.env.REACT_APP_API_BASE_URL+'/user', requestOptions).then(additionalUserData => {

                if (!additionalUserData.ok) {
                    return Promise.reject(additionalUserData.statusText);
                }

                return additionalUserData.json().then((jsonData) =>{
                    let user = JSON.parse(localStorage.getItem('hmtguser'));

                    for(var key in jsonData) {user[key] = jsonData[key];}
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('hmtguser', JSON.stringify(user));
                    return user;
                });
            });
        });
}

function deactivateUser(userItem) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };

    return fetch(process.env.REACT_APP_API_BASE_URL+'/user/'+userItem.mail, requestOptions).then(handleResponse);
}


function activateUser(userItem) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(process.env.REACT_APP_API_BASE_URL+'/user/activate/'+userItem.mail, requestOptions).then(handleResponse);
}

function register(user) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(user)
    };

    return fetch(process.env.REACT_APP_API_BASE_URL+'/user', requestOptions).then(handleResponse);
}

function activateAccount(externalId,newPassword,newPasswordMatch) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({externalId,newPassword,newPasswordMatch})
    };

    return fetch(process.env.REACT_APP_API_BASE_URL+'/activate', requestOptions).then(handleResponse);
}

function updateUser(user) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(user)
    };
    return fetch(process.env.REACT_APP_API_BASE_URL+'/user', requestOptions).then(handleResponse);
}

function setUpResetPassword(mail) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({mail})
    };

    return window.fetch(process.env.REACT_APP_API_BASE_URL+'/setupresetpassword', requestOptions).then(handleResponse);
};

function resetPassword(externalId,newPassword,newPasswordMatch) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({externalId,newPassword,newPasswordMatch})
    };

    return fetch(process.env.REACT_APP_API_BASE_URL+'/resetpassword', requestOptions).then(handleResponse);
}

function toggleRetirement(userId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: {}
    };

    return fetch(process.env.REACT_APP_API_BASE_URL + '/user/retire/' + userId, requestOptions).then(handleResponse);
}
